import http from '@/api/http'
import { assertCourierApi, courierRequest } from '@/entities/courier/api/courierRequest'
import { COURIER_AVAILABILITY } from '@/entities/courier/model/courierAvailability'

function toBackendCourierStatus(status) {
  if (status === COURIER_AVAILABILITY.ONLINE) {
    return 'ONLINE'
  }
  if (status === COURIER_AVAILABILITY.OFFLINE) {
    return 'OFFLINE'
  }
  return null
}

function mapBackendCourierStatus(raw) {
  const upper = String(raw ?? '').toUpperCase()
  if (upper === 'ONLINE' || upper === 'BUSY') {
    return COURIER_AVAILABILITY.ONLINE
  }
  if (upper === 'OFFLINE') {
    return COURIER_AVAILABILITY.OFFLINE
  }
  return null
}

function mapActiveOrderIds(payload = {}) {
  if (Array.isArray(payload.active_order_ids)) {
    return payload.active_order_ids.map((id) => String(id)).filter(Boolean)
  }
  if (payload.active_order_id != null && payload.active_order_id !== '') {
    return [String(payload.active_order_id)]
  }
  return []
}

function mapCourierProfileBody(body) {
  const payload = body?.data ?? {}
  const activeOrderIds = mapActiveOrderIds(payload)
  const courierId =
    payload.id != null && payload.id !== '' ? String(payload.id) : null
  const backendStatus = String(payload.status ?? '').toUpperCase()
  const mappedStatus = mapBackendCourierStatus(payload.status)

  return {
    courierId,
    activeOrderIds,
    status: activeOrderIds.length
      ? COURIER_AVAILABILITY.ONLINE
      : mappedStatus ?? COURIER_AVAILABILITY.OFFLINE,
    backendStatus,
  }
}

function mapStatusResponse(body) {
  const payload = body?.data ?? {}
  const status = mapBackendCourierStatus(payload.status)
  const courierId =
    payload.id != null && payload.id !== '' ? String(payload.id) : null

  return {
    status: status ?? COURIER_AVAILABILITY.OFFLINE,
    courierId,
    activeOrderIds: mapActiveOrderIds(payload),
  }
}

export async function fetchCourierProfileApi() {
  assertCourierApi()
  const body = await courierRequest(() => http.get('/courier/profile'))
  return mapCourierProfileBody(body)
}

export async function updateCourierAvailabilityApi(status) {
  const backendStatus = toBackendCourierStatus(status)
  if (!backendStatus) {
    return { status, courierId: null, activeOrderIds: [] }
  }

  assertCourierApi()
  const body = await courierRequest(() =>
    http.post('/courier/status', { status: backendStatus }),
  )
  return mapStatusResponse(body)
}

export async function postCourierLocationApi({ lat, lng }) {
  assertCourierApi()
  await courierRequest(() => http.post('/courier/location', { lat, lng }))
}
